import { Button, Chip } from '@material-ui/core';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange, t }) => {
  return (
    <div className="flex gap-2 justify-center mb-8 flex-wrap">
      {categories.map((category) => (
        <Button
          key={category.id}
          variant={selectedCategory === category.id ? 'contained' : 'outlined'}
          className={
            selectedCategory === category.id
              ? 'bg-stone-700 hover:bg-stone-600 text-white'
              : 'border-stone-600 text-stone-700 hover:bg-stone-100'
          }
          onClick={() => onCategoryChange(category.id)}
        >
          {t(`gallery.filter.${category.id}`)}
          <Chip
            label={category.count}
            size="small"
            className={`ml-2 ${
              selectedCategory === category.id
                ? 'bg-white text-stone-700'
                : 'bg-stone-200 text-stone-700'
            }`}
            style={{ height: '20px', fontSize: '0.75rem' }}
          />
        </Button>
      ))}
    </div>
  );
};

export default CategoryFilter;
